import { PaymentStatus } from 'src/types'

const PAYMENT_STATUS_COLORS: Record<PaymentStatus, string> = {
  green: '#dcfce7',
  yellow: '#fef9c3',
  red: '#fee2e2',
  white: '#ffffff'
}

const getPaymentStatusColor = (status: PaymentStatus | null | undefined): string => {
  // eslint-disable-next-line no-undefined
  if (status === null || status === undefined) {
    return '#ffffff'
  }
  return PAYMENT_STATUS_COLORS[status]
}

export default getPaymentStatusColor
